import { Injectable } from '@angular/core';
import {HttpManagerService}  from '../../api/httpmanager.service';
import {ApiConstant} from '../api.constant';

@Injectable()
export class NewprojectService {

  private mainurl : String;
  constructor(private httpmanagerService: HttpManagerService,private apiservice: ApiConstant) { 
    this.mainurl = apiservice.Server;
  }

  allnewproject(): Promise<any> {
    return this.httpmanagerService.HttpGet('newproject', '').then(data => {
        if (data) {
            return data.data;
        }
    })
}

dHiring(id): Promise<any>{
  return this.httpmanagerService.HttpDelete('newproject',id).then(data =>{
      return data;
  })
}

downloadFile(name)
{
  
    this.mainurl=this.apiservice.ServerUrl;
    window.location.href=this.mainurl+'uploads/newproject/'+name;
}

}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/newproject/newproject.service.ts